export default __webpack_public_path__ + "static/media/arrow-down.17c7d4f5.svg";